import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled, theme } from "../theme";
import { Icon } from "../icon";
export const DropdownMenuButton = ({ open, children, ...rest }) => (_jsxs(Wrapper, { className: rest.className, ...rest, children: [children, _jsx(IconWrapper, { children: _jsx(Icon, { name: open ? "up" : "down", size: 12, color: theme.color.darkBlue100 }) })] }));
const Wrapper = styled.div `
  align-items: center;
  display: inline-flex;
  cursor: pointer;
  user-select: none;
`;
const IconWrapper = styled.div `
  margin-left: 5px;
`;
